import { Box } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import DarkModeToggle from 'components/common/DarkModeToggle';
import SidebarSection from './SidebarSection';
import useEntities from 'features/IRWorkstation/hooks/useEntities';
import { useIRWorkstation } from 'features/IRWorkstation/contexts/IRWorkstationContext';
import FeedbackDrawer from 'features/IRWorkstation/components/Feedback/FeedbackDrawer';
import PrimaryButton from 'features/IRWorkstation/components/Common/Buttons/PrimaryButton';
import SecondaryButton from 'features/IRWorkstation/components/Common/Buttons/SecondaryButton';

// Track Events
import { useTrackEvent } from 'hooks/useTrackEvent';
import { ButtonClickTargets } from 'constants/buttonClickTargets';

const IrWorkstationSidebar = () => {
	const navigate = useNavigate();
	const { tenant } = useIRWorkstation();
	const [feedbackDrawerOpen, setFeedbackDrawerOpen] = useState(false);
	const { trackButtonClick } = useTrackEvent({ tenant, product: 'IEM' });

	const {
		entities,
		loading: entitiesLoading,
		error: entitiesError,
	} = useEntities(3);

	return (
		<Box
			width={200}
			flexShrink={0}
			backgroundColor='background.paper'
			borderRight='0.5px solid'
			borderColor='border.light'
			overflow='auto'
			py='12px'
			display='flex'
			flexDirection='column'
		>
			<Box flex={1}>
				<SidebarSection label='My day'>
					<SidebarSection.Item name='Work Queue' tooltip='Coming soon!' />
					<SidebarSection.Item name='Alerts' tooltip='Coming soon!' />

					{/* SS-2816 - hiding for now
					<SidebarSection.Item
						name='Activity feed'
						badge={18}
						badgeColor='gray'
					/>
					*/}
				</SidebarSection>

				<SidebarSection label='Coverage'>
					<SidebarSection.Item name='All LPs' tooltip='Coming soon!' />

					{/* See SS-2818. We will actually implement these at a later date.

					<SidebarSection.Item name='Tier 1' badge={12} badgeColor='gray' />
					<SidebarSection.Item name='At risk' badge={2} badgeColor='red' />
					<SidebarSection.Item name='Re-up pipeline' />

					*/}
				</SidebarSection>

				<SidebarSection label='Entities'>
					{entitiesLoading ? (
						<SidebarSection.Skeleton count={3} />
					) : entitiesError ? (
						<SidebarSection.Item
							name={entitiesError}
							textColor='error.main'
							disabled
						/>
					) : entities?.length === 0 ? (
						<SidebarSection.Item name='No entities found' disabled />
					) : (
						<>
							{entities?.map((entity) => (
								<SidebarSection.Item
									key={entity.id}
									name={entity.name}
									onClick={() => {
										trackButtonClick(ButtonClickTargets.LeftNavEntitySelection);
										navigate(`entities/${entity.id}`);
									}}
								/>
							))}
						</>
					)}
					<SidebarSection.Item
						name='All entities'
						onClick={() => {
							trackButtonClick(ButtonClickTargets.LeftNavAllEntities);
							navigate('entities');
						}}
					/>
				</SidebarSection>
			</Box>

			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center'
				}}
			>
				<DarkModeToggle sx={{ mb: '8px' }} />

				<Box
					sx={{
						padding: '0px 12px 0px 12px',
						margin: '0px 0px 12px 0px',
					}}
				>
					<SecondaryButton
						onClick={() => {
							setFeedbackDrawerOpen(true);
						}}
						loading={false}
						disabled={false}
						label='Submit Feedback'					
					/>
				</Box>

				<Box
					sx={{
						padding: '0px 12px 12px 12px',		
					}}
				>
					<PrimaryButton
						onClick={() => {
							trackButtonClick(ButtonClickTargets.LeftNavBackLaunchpad);
							navigate('/');
						}}
						loading={false}
						disabled={false}
						label='Back to Launchpad'
					/>
				</Box>
			</Box>

			{feedbackDrawerOpen && (
				<FeedbackDrawer
					open={feedbackDrawerOpen}
					onClose={() => {
						setFeedbackDrawerOpen(false);
					}}
					tenant={tenant}
				/>
			)}
		</Box>
	);
};

export default IrWorkstationSidebar;
